//Граница 1240px — та же, что в стилях конфигуратора
function isDesktopLayout() {
    return window.matchMedia('(min-width: 1240px)').matches;
}

//Картинку не выбрали в админке — в данных null
function hasImageUrl(url) {
    return typeof url === 'string' && url !== '';
}

//Без картинки на экране место пустое, запроса по неверному адресу нет — без ошибки в консоли нехватку
//не заметить
function reportOptionsWithoutImage(catalog) {
    catalog.options.forEach(option => {
        const variations = [...catalog.optionVariations.values()]
            .filter(variation => variation['option_id'] === option['id']);
        const isSingle = option['type'] === 'single';
        if (isSingle) {
            const group = catalog.optionGroups.get(option['group_id']);
            if (!hasImageUrl(group?.['preview_url'])) {
                console.error('Нет картинки: группа опций «' + group?.['title'] + '», опция «' + option['title'] + '»');
            }
            if (variations.length === 1) return;
        }
        variations.forEach(variation => {
            if (!hasImageUrl(variation['preview_url'])) {
                console.error('Нет картинки: опция «' + option['title'] + '», вариант «' + variation['title'] + '»');
            }
        });
    });
}

//Уменьшенной копии нет у «ткани по каталогу» и в кеше, собранном до появления поля
function getFabricPreviewUrl(fabric) {
    return fabric['preview_small_url'] || fabric['preview_url'];
}

//«Ткань по каталогу» добавляется на каждую категорию: id — порядковый номер категории, фактура 0
function parseProductCatalog(productForm) {
    const catalog = {
        variations: new Map(),
        fabrics: new Map(),
        fabricColors: new Map(),
        fabricCategories: new Map(),
        fabricTextures: new Map(),
        fabricProperties: new Map(),
        options: new Map(),
        optionGroups: new Map(),
        optionVariations: new Map()
    };

    //Вариации
    JSON.parse(productForm.dataset.product_variations || '[]')
        .forEach(variation => catalog.variations.set(Number(variation['variation_id']), variation));
    //Ткани
    const fabricObject = JSON.parse(productForm.dataset.fabric_object || '{}');
    if (fabricObject['fabrics']) fabricObject['fabrics'].forEach(fabric => catalog.fabrics.set(fabric['id'], fabric));
    if (fabricObject['colors']) fabricObject['colors'].forEach(color => catalog.fabricColors.set(color['id'], color));
    if (fabricObject['categories']) {
        fabricObject['categories'].forEach((category, index) => {
            category['name'] = /^\d+$/.test(category['name']) ? Number(category['name']) : category['name'];
            catalog.fabricCategories.set(category['id'], category);

            catalog.fabrics.set(index, {
                'id': index,
                'slug': '',
                'sku': '',
                'title': 'Ткань ' + category['name'] + ' категории',
                'description': '',
                'type': 'catalog',
                'preview_url': '/wp-content/themes/savoy-child/assets/img/fabric-catalog.png',
                'gallery_urls': [],
                'color_id': '',
                'category_id': category['id'],
                'texture_id': 0,
                'property_ids': [],
                'collection': '',
                'martindale': '',
                'density': '',
                'composition': '',
                'country': '',
                'ncs': '',
                'ral': '',
                'popularity': ''
            });
        });
    }
    if (fabricObject['textures']) {
        fabricObject['textures'].forEach(texture => catalog.fabricTextures.set(texture['id'], texture));

        catalog.fabricTextures.set(0, {
            'id': 0,
            'name': 'По каталогу'
        });
    }
    if (fabricObject['properties']) fabricObject['properties'].forEach(property => catalog.fabricProperties.set(property['id'], property));
    //Опции
    const optionsObject = JSON.parse(productForm.dataset.option_object || '{}');
    if (optionsObject['options']) optionsObject['options'].forEach(option => catalog.options.set(option['id'], option));
    if (optionsObject['groups']) optionsObject['groups'].forEach(group => catalog.optionGroups.set(group['id'], group));
    if (optionsObject['variations']) optionsObject['variations'].forEach(variation => catalog.optionVariations.set(variation['id'], variation));

    return catalog;
}

//Итог на странице считает getProductTotalPrice() — на крайних данных (количество 0, категория без наценки)
//его числа расходятся с расчётами сайдбаров

//У простого товара current_variation — пустой объект
function getSelectedProduct() {
    return current_variation ? current_variation : JSON.parse(productForm.dataset.product);
}

function getBasePrice() {
    return getSelectedProduct()['display_price'];
}

function getFabricCategoryPrice(id, catalog) {
    return calcFabricPriceOrZero(getBasePrice(), catalog.fabricCategories.get(Number(id)));
}

function getOptionVariationPrice(id, catalog, count = 1) {
    return calcOptionPrice(getBasePrice(), catalog.optionVariations.get(id), Number(count));
}

function getTotalPrice(catalog) {
    let price = getBasePrice();

    if (current_fabric) {
        price += getFabricCategoryPrice(Number(current_fabric['category_id']), catalog);
    }
    if (current_options_variations) {
        current_options_variations.forEach(optionVariation => {
            price += getOptionVariationPrice(optionVariation['id'], catalog, optionVariation['count'] ?? 1);
        });
    }

    return price;
}

//Строки при загрузке выводит PHP. Выбор по умолчанию (первые fabric_changed и options_changed) строки
//не меняет; первый show_variation сюда не приходит — список создаётся во время него
class ConstructorSummary {
    constructor(list) {
        this.list = list;
        this.isFabricFirstCall = true;
        this.isOptionsFirstCall = true;

        jQuery(productForm).on('show_variation', (event, variation) => this.renderSize(variation));
        jQuery(productForm).on('fabric_changed', (event, fabric) => {
            if (this.isFabricFirstCall) {
                this.isFabricFirstCall = false;
                return;
            }
            this.renderFabric(fabric);
        });
        jQuery(productForm).on('options_changed', (event, variations, groups, options) => {
            if (this.isOptionsFirstCall) {
                this.isOptionsFirstCall = false;
                return;
            }
            this.renderOptions(variations, groups, options);
        });
        //Обработчик — на body: дальше него клик по корзине не доходит
        document.body.addEventListener('click', event => {
            const removeTrigger = event.target.closest('.remove-option-trigger');
            if (!removeTrigger) return;
            event.stopPropagation();

            const id = Number(removeTrigger.dataset.id);
            const removedVariation = current_options_variations.find(variation => variation['id'] === id);
            const new_options_variations = current_options_variations.filter(variation => variation['id'] !== id);
            //Опция и группа убираются, только если у них не осталось других выбранных вариантов
            const removedId = key => removedVariation
                && !new_options_variations.some(variation => variation[key] === removedVariation[key])
                ? removedVariation[key] : undefined;
            const removedOptionId = removedId('option_id');
            const removedGroupId = removedId('group_id');
            const new_options = current_options.filter(option => option['id'] !== removedOptionId);
            const new_options_groups = current_options_groups.filter(group => group['id'] !== removedGroupId);

            jQuery(productForm).trigger('options_changed', [new_options_variations, new_options_groups, new_options]);
        });
    }

    renderSize(variation) {
        const attributeLabelKey = Object.values(variation['attributes'])[0];
        const value = this.list?.querySelector('.item.size .product-constructor__item-value');
        if (value) {
            value.innerHTML = variation['attribute_labels'][attributeLabelKey];
        }

        const image = this.list?.querySelector('.item.size .product-constructor__item-image');
        if (image) {
            if (image.tagName === 'IMG') {
                image.src = variation['image']['thumb_src'];
            }
        }
    }

    renderFabric(fabric) {
        if (!this.list) return;

        const item = document.createElement('div');
        item.classList.add('product-constructor__item', 'item', 'fabric');
        this.list.querySelector('.item.fabric').replaceWith(item);

        const wrapper = document.createElement('a');
        wrapper.classList.add('product-constructor__item-wrapper', 'product-constructor-sidebar-trigger');
        item.append(wrapper);

        const image = document.createElement('img');
        image.classList.add('product-constructor__item-image');
        image.src = fabric['preview_url'];
        wrapper.append(image);

        const title = document.createElement('span');
        title.classList.add('product-constructor__item-title');
        title.innerHTML = 'Ткань: ' + fabric['title'];
        wrapper.append(title);

        const edit = document.createElement('div');
        edit.classList.add('product-constructor__item-edit');
        wrapper.append(edit);
    }

    //Опция single с одним вариантом — картинка группы и название опции. Обязательную опцию убрать нельзя —
    //вместо корзины значок редактирования
    renderOptions(variations, groups, options) {
        if (!this.list) return;

        this.list.querySelectorAll('.item.option').forEach(item => item.remove());

        const content = document.createDocumentFragment();
        options.forEach(option => {
            const group = groups.find(group => group['id'] === option['group_id']);
            variations.filter(variation => variation['option_id'] === option['id']).forEach((variation, index, variations) => {
                const isSingleVariation = option['type'] === 'single' && variations.length === 1;

                const item = document.createElement('div');
                item.classList.add('product-constructor__item', 'item', 'option');
                content.appendChild(item);

                const wrapper = document.createElement('div');
                wrapper.classList.add('product-constructor__item-wrapper', 'product-constructor-sidebar-trigger');
                item.append(wrapper);

                const imageUrl = isSingleVariation ? group['preview_url'] : variation['preview_url'];
                if (hasImageUrl(imageUrl)) {
                    const image = document.createElement('img');
                    image.classList.add('product-constructor__item-image');
                    image.src = imageUrl;
                    wrapper.append(image);
                } else {
                    item.classList.add('no-image');
                }

                const title = document.createElement('span');
                title.classList.add('product-constructor__item-title');
                title.innerHTML = isSingleVariation ? option['title'] : variation['title'];
                wrapper.append(title);

                if (option['type'] !== 'required') {
                    const remove = document.createElement('a');
                    remove.classList.add('product-constructor__item-trash', 'remove-option-trigger');
                    remove.dataset.id = variation['id'];
                    item.append(remove);
                } else {
                    const edit = document.createElement('div');
                    edit.classList.add('product-constructor__item-edit');
                    wrapper.append(edit);
                }
            });
        });

        this.list.appendChild(content);
    }
}

//filters: {search, catalog, price: {min, max}, property: [id], color: [id], texture: [id], category: [id]}

function getCountFabricFilters(filters) {
    let count = 0;
    for (const value of Object.values(filters)) {
        if (typeof value === 'string' || typeof value === 'number') {
            count++;
        } else if (typeof value === 'object') {
            count += getCountFabricFilters(value);
        }
    }

    return count;
}

//Поиск на кнопке фильтров не считается, и кнопки сброса из-за него не появляются
function getCountFabricFiltersWithoutSearch(filters) {
    const {search, ...otherFilters} = filters;
    return getCountFabricFilters(otherFilters);
}

function clearFabricFiltersExceptSearch(filters) {
    Object.keys(filters).forEach(key => {
        if (key !== 'search') delete filters[key];
    });
}

function getFabricPriceRange(filters, catalog, basePrice) {
    const priceMultiples = [];
    catalog.fabricCategories.forEach((category) => {
        if (!category['isEmpty'] || filters['catalog']) {
            priceMultiples.push(category['price-multiple']);
        }
    });

    return {
        'min': Math.round(basePrice * (1 + Math.min(...priceMultiples)) / 100) * 100,
        'max': Math.round(basePrice * (1 + Math.max(...priceMultiples)) / 100) * 100
    };
}

//Поиск и остальные фильтры действуют вместе и друг друга не сбрасывают
function setFabricFilter(filters, group, id, value, catalog, basePrice) {
    if (!isNaN(parseFloat(id)) && isFinite(id)) id = Number(id);

    //Поиск
    if (id === 'search') {
        value = value.trim();
        if (value) {
            filters['search'] = value;
        } else {
            delete filters['search'];
        }
    }
    if (['property', 'color', 'texture', 'category'].includes(group)) {
        if (value) {
            (filters[group] ||= []).push(id);
        } else {
            filters[group] = filters[group].filter(_id => _id !== id);
        }
    }
    //Каталог
    else if (id === 'catalog') {
        filters['catalog'] = value;
    }
    else if (group === 'price') {
        const priceRange = getFabricPriceRange(filters, catalog, basePrice);

        if (id === 'min') {
            let minPrice = parseInt(value.replace(/\D/g, ''), 10);
            let maxPrice = filters['price']?.['max'] ?? priceRange['max'];

            if (!minPrice) {
                minPrice = priceRange['min'];
            } else if (minPrice < priceRange['min']) {
                minPrice = priceRange['min'];
            } else if (minPrice > maxPrice) {
                minPrice = maxPrice;
            }

            (filters['price'] ||= {})['min'] = minPrice;
        } else if (id === 'max') {
            let minPrice = filters['price']?.['min'] ?? priceRange['min'];
            let maxPrice = parseInt(value.replace(/\D/g, ''), 10);

            if (!maxPrice) {
                maxPrice = priceRange['max'];
            } else if (maxPrice > priceRange['max']) {
                maxPrice = priceRange['max'];
            } else if (maxPrice < minPrice) {
                maxPrice = minPrice;
            }

            (filters['price'] ||= {})['max'] = maxPrice;
        }
    }
}

//null — у размера нет 3D-модели со списком тканей
function getZarboFabricSkus() {
    const selectedProduct = getSelectedProduct();
    const product = typeof selectedProduct === 'object' && Object.keys(selectedProduct).length
        ? selectedProduct : JSON.parse(productForm.dataset.product || '{}');
    const skus = product?.['zarbo']?.['shaders']?.['Ткань'];

    return Array.isArray(skus) && skus.length ? skus : null;
}

function isFabricInZarbo(fabric) {
    return Boolean(fabric?.['sku']) && Boolean(getZarboFabricSkus()?.includes(fabric['sku']));
}

function renderFabricArMark(item, fabric) {
    const mark = item.querySelector('.product-constructor-sidebar__fabric-ar');
    if (mark) mark.hidden = !isFabricInZarbo(fabric);
}

function filterFabricsItems(items, filters, catalog, basePrice) {
    return items.filter(item => {
        //Поиск
        if (filters['search']) {
            const search = filters['search'].toLowerCase();
            const slugSearch = search.replace(/\./g, '-');
            let isMatched = [
                [item['slug'], slugSearch],
                [item['title'], search],
                [item['description'], search],
                [item['composition'], search],
                [item['collection'], search],
                [item['country'], search],
            ].some(([value, query]) => String(value ?? '').toLowerCase().includes(query));

            //Цвет
            const color = catalog.fabricColors.get(item['color_id']);
            if (color?.['name'].toLowerCase().includes(search)) isMatched = true;
            //Фактура
            const texture = catalog.fabricTextures.get(item['texture_id']);
            if (texture?.['name'].toLowerCase().includes(search)) isMatched = true;
            //Свойства
            for (let propertyID of item['property_ids'] ?? []) {
                const property = catalog.fabricProperties.get(propertyID);
                if (property?.['name'].toLowerCase().includes(search)) isMatched = true;
            }

            if (!isMatched) return false;
        }
        if (filters['price']?.['min'] || filters['price']?.['max']) {
            const price = basePrice + calcFabricPriceOrZero(basePrice, catalog.fabricCategories.get(Number(item['category_id'])));
            if (filters['price']['min'] && filters['price']['min'] > price) return false;
            if (filters['price']['max'] && price > filters['price']['max']) return false;
        }
        //Категория
        if (filters['category']?.length && !filters['category']?.includes(item['category_id'])) return false;
        //Каталог
        if (item['type'] === 'catalog') return filters['catalog'];
        //Свойства
        if (filters['property']?.length && !item['property_ids']?.some(id => filters['property'].includes(id))) return false;
        //Цвет
        if (filters['color']?.length && !filters['color']?.includes(item['color_id'])) return false;
        //Фактура
        if (filters['texture']?.length && !filters['texture']?.includes(item['texture_id'])) return false;

        return true;
    });
}

//Результат: {имя категории: {id, items: {имя фактуры: {id, items: [ткани]}}}}
function groupFabricItems(items, catalog) {
    const fabrics = {};

    items.forEach(item => {
        const category = catalog.fabricCategories.get(item['category_id']);
        if (category) {
            const categoryName = /^\d+$/.test(category['name']) ? Number(category['name']) : category['name'];

            if (!fabrics[categoryName]) {
                fabrics[categoryName] = {
                    'id': item['category_id'],
                    'items': {}
                };
            }

            const texture = catalog.fabricTextures.get(item['texture_id']);
            if (texture) {
                if (!fabrics[categoryName]['items'][texture['name']]) {
                    fabrics[categoryName]['items'][texture['name']] = {
                        'id': item['texture_id'],
                        'items': []
                    };
                }

                fabrics[categoryName]['items'][texture['name']]['items'].push(item);
            }
        }
    });

    return fabrics;
}

//Числа — по значению: «2» раньше «10»
function sortFabricItems(fabrics) {
    const {compare} = new Intl.Collator(undefined, {numeric: true});

    Object.keys(fabrics).forEach(categoryName => {
        Object.keys(fabrics[categoryName]['items']).forEach(textureName => {
            fabrics[categoryName]['items'][textureName]['items'].sort((a, b) => compare(a['title'], b['title']));
        });
    });

    return fabrics;
}

//Открыта ли панель фильтров — не меняется
function renderFabricFiltersBlock(block, filters, catalog, basePrice) {
    const count = getCountFabricFiltersWithoutSearch(filters);

    block.querySelector('input.filter[type="search"]').value = filters['search'] ?? '';

    const filterTrigger = block.querySelector('.fabric-filter-trigger');
    filterTrigger.querySelector('.product-constructor-sidebar__filter-count')?.remove();
    if (count > 0) {
        const filterCount = document.createElement('span');
        filterCount.classList.add('product-constructor-sidebar__filter-count');
        filterCount.innerHTML = count;
        filterTrigger.appendChild(filterCount);
    }

    renderFabricFiltersPanel(block, filters, catalog, basePrice);
}

//Категория без тканей видна, только когда отмечен «По каталогу»
function renderFabricFiltersPanel(block, filters, catalog, basePrice) {
    block.querySelectorAll('input.filter[type="checkbox"]').forEach(input => {
        let id = input.dataset.id;
        if (!isNaN(parseFloat(id)) && isFinite(id)) id = Number(id);

        if (id === 'catalog') {
            input.checked = Boolean(filters['catalog']);
            return;
        }
        input.checked = Boolean(filters[input.dataset.group]?.includes(id));
        if (input.dataset.group === 'category') {
            input.closest('label').hidden = Boolean(catalog.fabricCategories.get(id)?.['isEmpty'] && !filters['catalog']);
        }
    });

    const inputPriceMin = block.querySelector('input.filter[data-group="price"][data-id="min"]');
    const inputPriceMax = block.querySelector('input.filter[data-group="price"][data-id="max"]');
    if (inputPriceMin && inputPriceMax) {
        const priceRange = getFabricPriceRange(filters, catalog, basePrice);
        inputPriceMin.value = new Intl.NumberFormat("ru-RU").format(filters['price']?.['min'] ?? priceRange['min']);
        inputPriceMax.value = new Intl.NumberFormat("ru-RU").format(filters['price']?.['max'] ?? priceRange['max']);
    }

    block.querySelector('.fabric-reset-filter-trigger').classList.toggle('active', getCountFabricFiltersWithoutSearch(filters) > 0);
}

//Ниже 1240 окно фильтров после сброса не открывается
function openFabricFiltersBlock(block) {
    if (!isDesktopLayout()) return;

    block.querySelector('.fabric-filter-body').classList.add('open');
    block.querySelector('.fabric-filter-trigger').classList.add('active');
}

//Ниже 1240 выбранное в окне фильтров применяется только по «Показать ткани»; крестик, затемнение, Esc
//и переход ширины через 1240 закрывают окно без применения. «Сбросить фильтр» в окне сбрасывает
//и применённые фильтры сразу
function bindFabricFiltersBlocks(root, catalog, actions) {
    const inputsAppliedByEnter = new WeakSet();
    let filterWindow = null;

    const openFilterWindow = block => {
        filterWindow = {'block': block, 'filters': structuredClone(actions.getFilters())};
        renderFabricFiltersPanel(block, filterWindow.filters, catalog, actions.getBasePrice());
        block.querySelector('.fabric-filter-body').classList.add('window-open');
    };
    //apply = false — отметки в окне возвращаются к применённым фильтрам
    const closeFilterWindow = apply => {
        if (!filterWindow) return;

        //Браузер присылает изменение поля при уходе из него, а на телефоне касание кнопки курсор из поля
        //убирает не всегда
        if (filterWindow.block.contains(document.activeElement)) document.activeElement.blur();

        const {block, filters: windowFilters} = filterWindow;
        filterWindow = null;
        block.querySelector('.fabric-filter-body').classList.remove('window-open');
        if (apply) {
            const filters = actions.getFilters();
            Object.keys(filters).forEach(key => delete filters[key]);
            Object.assign(filters, windowFilters);
            actions.onChange();
        } else {
            renderFabricFiltersPanel(block, actions.getFilters(), catalog, actions.getBasePrice());
        }
    };

    jQuery(root).on('click', '.clear-search-trigger', event => {
        const searchInput = event.currentTarget.parentNode.querySelector('input[type="search"]');
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input', {'bubbles': true}));
    });
    jQuery(root).on('click', '.fabric-filter-trigger', event => {
        const filtersBlock = event.currentTarget.closest('.block-fabrics-filters');
        const filterBody = filtersBlock?.querySelector('.fabric-filter-body');
        if (!filterBody) return;

        if (!isDesktopLayout()) {
            openFilterWindow(filtersBlock);
            return;
        }
        filterBody.classList.toggle('open');
        event.currentTarget.classList.toggle('active', filterBody.classList.contains('open'));
    });
    jQuery(root).on('click', '.fabric-filter-apply-trigger', () => closeFilterWindow(true));
    jQuery(root).on('click', '.fabric-filter-close-trigger', () => closeFilterWindow(false));
    jQuery(root).on('click', '.fabric-filter-body', event => {
        if (event.target === event.currentTarget) closeFilterWindow(false);
    });
    window.matchMedia('(min-width: 1240px)').addEventListener('change', () => closeFilterWindow(false));
    jQuery(root).on('keydown', 'input.filter', event => {
        //Запрещаем ввод букв в поле с типом число
        if ((event.currentTarget.type === 'number' || event.currentTarget.inputmode === 'numeric') && isLetterEntered(event)) {
            event.preventDefault();
        }
        //Браузер при уходе из поля пришлёт своё изменение — поле запоминаем, чтобы не применять значение дважды
        if (event.key === 'Enter') {
            event.preventDefault();
            if (event.currentTarget.type !== 'search') {
                event.currentTarget.dispatchEvent(new CustomEvent('change', {'bubbles': true}));
                inputsAppliedByEnter.add(event.currentTarget);
            }
        }
    });
    //Новое значение после Enter применится по изменению от браузера при уходе из поля
    jQuery(root).on('input', 'input.filter', event => {
        inputsAppliedByEnter.delete(event.currentTarget);
    });
    jQuery(root).on('input', 'input.filter[type="search"]', event => {
        event.preventDefault();
        setFabricFilter(actions.getFilters(), event.currentTarget.dataset.group, event.currentTarget.dataset.id, event.target.value,
            catalog, actions.getBasePrice());
        actions.onSearch();
    });
    //Применить фильтр
    jQuery(root).on('change', 'input.filter:not([type="search"])', event => {
        //Изменение от браузера при уходе из поля, значение которого уже применено по Enter
        if (event.originalEvent?.isTrusted && inputsAppliedByEnter.has(event.currentTarget)) {
            inputsAppliedByEnter.delete(event.currentTarget);
            return;
        }
        const value = event.currentTarget.type === 'checkbox' ? event.target.checked : event.target.value;
        if (filterWindow?.block.contains(event.currentTarget)) {
            setFabricFilter(filterWindow.filters, event.currentTarget.dataset.group, event.currentTarget.dataset.id, value,
                catalog, actions.getBasePrice());
            renderFabricFiltersPanel(filterWindow.block, filterWindow.filters, catalog, actions.getBasePrice());
            return;
        }
        setFabricFilter(actions.getFilters(), event.currentTarget.dataset.group, event.currentTarget.dataset.id, value,
            catalog, actions.getBasePrice());
        actions.onChange();
    });
    jQuery(root).on('click', '.fabric-reset-filter-trigger', event => {
        const filters = actions.getFilters();
        if (filterWindow?.block.contains(event.currentTarget)) {
            if (getCountFabricFiltersWithoutSearch(filters) === 0
                && getCountFabricFiltersWithoutSearch(filterWindow.filters) === 0) return;
            clearFabricFiltersExceptSearch(filterWindow.filters);
        }
        clearFabricFiltersExceptSearch(filters);
        actions.onReset();
    });
}

//type — main (отмечена выбранная ткань, метки «AR») или sample (отмечены выбранные образцы)
function renderFabricsBlock(block, type, filters, catalog, basePrice) {
    const template = document.querySelector('template.product-constructor-fabric-template');
    const content = document.createDocumentFragment();

    let fabrics = filterFabricsItems([...catalog.fabrics.values()], filters, catalog, basePrice);
    if (fabrics.length > 0) {
        //Сгруппировать ткани
        fabrics = groupFabricItems(fabrics, catalog);
        //Сортировать ткани
        fabrics = sortFabricItems(fabrics);

        const list = document.createElement('div');
        list.classList.add('product-constructor-sidebar__fabrics', 'fabrics');
        content.appendChild(list);

        Object.keys(fabrics).forEach(categoryName => {
            //«+», число и «₽» не разрываются переносом
            let fabricPrice = calcFabricPriceOrZero(basePrice, catalog.fabricCategories.get(Number(fabrics[categoryName]['id'])));
            if (fabricPrice) {
                fabricPrice = '+\u00a0' + new Intl.NumberFormat("ru-RU").format(fabricPrice) + '\u00a0₽';
            } else {
                fabricPrice = 'не влияют на стоимость';
            }

            const categoryTitle = document.createElement('span');
            categoryTitle.classList.add('product-constructor-sidebar__fabric-category-title');
            categoryTitle.innerHTML = '<b>Ткани ' + categoryName + ' категории</b> ' + fabricPrice;
            list.appendChild(categoryTitle);

            Object.keys(fabrics[categoryName]['items']).forEach(textureName => {
                const textureTitle = document.createElement('span');
                textureTitle.classList.add('product-constructor-sidebar__fabric-texture-title');
                textureTitle.innerHTML = textureName;
                list.appendChild(textureTitle);

                fabrics[categoryName]['items'][textureName]['items'].forEach(fabric => {
                    const item = template.content.firstElementChild.cloneNode(true);
                    if (
                        (type === 'main' && fabric['id'] === current_fabric['id'])
                        || (type === 'sample' && current_fabrics_samples.some(sample => sample['id'] === fabric['id']))
                    ) {
                        item.classList.add('active');
                    }
                    if (type === 'main') renderFabricArMark(item, fabric);
                    item.dataset.id = String(fabric['id']);
                    //Картинка грузится, только когда карточка близко к видимой области списка (loading="lazy" в заготовке)
                    item.querySelector('.product-constructor-sidebar__fabric-image').src = getFabricPreviewUrl(fabric);
                    item.querySelector('.product-constructor-sidebar__fabric-title').innerHTML = fabric['title'];
                    list.appendChild(item);
                });
            });
        });
    } else {
        //Если ткани подходящие под фильтры отсутствуют
        const fabricsNotFound = document.createElement('div');
        fabricsNotFound.classList.add('product-constructor-sidebar__fabric-not-found');
        content.append(fabricsNotFound);

        const fabricsNotFoundTitle = document.createElement('span');
        fabricsNotFoundTitle.classList.add('product-constructor-sidebar__fabric-not-found-title');
        fabricsNotFoundTitle.innerHTML = 'Ткани не найдены';
        fabricsNotFound.appendChild(fabricsNotFoundTitle);

        if (getCountFabricFiltersWithoutSearch(filters) > 0) {
            const fabricResetFilterButton = document.createElement('a');
            fabricResetFilterButton.classList.add('product-constructor-sidebar__fabric-not-found-button');
            fabricResetFilterButton.classList.add('fabric-reset-filter-trigger', type);
            fabricResetFilterButton.innerHTML = 'Сбросить фильтр';
            fabricsNotFound.appendChild(fabricResetFilterButton);
        }
    }

    block.replaceChildren(content);
}

const variationGalleryThumbnails = new Swiper('.variation-gallery .thumbnail', {
    'wrapperClass': 'wrapper',
    'slideClass': 'slide',
    'slidesPerView': 'auto',
    'rewind': true
});

new Swiper('.variation-gallery .main', {
    'wrapperClass': 'wrapper',
    'slideClass': 'slide',
    'slidesPerView': 'auto',
    'rewind': true,
    'thumbs': {
        'swiper': variationGalleryThumbnails
    },
    'pagination': {
        'el': '.variation-gallery__counter',
        'type': 'fraction',
        'renderFraction': (currentClass, totalClass) =>
            `<span class="${currentClass}"></span> из <span class="${totalClass}"></span>`
    }
});

//false — 3D-модель для выбора недоступна
function buildZarboUrl(product, fabric, optionVariations, options) {
    if (typeof product !== 'object' || !Object.keys(product).length) return false;

    //Все шейдеры товара/вариации
    let allProductShaders = {};
    if (
        typeof product['zarbo'] === 'object' && Object.keys(product['zarbo']).length
        && typeof product['zarbo']['shaders'] === 'object' && Object.keys(product['zarbo']['shaders']).length
    ) {
        allProductShaders = product['zarbo']['shaders'];
    }
    if (typeof allProductShaders !== 'object' || !Object.keys(allProductShaders).length) return false;

    //Применяемые шейдеры
    const appliedShaders = {};
    //Ткань
    if (typeof fabric === 'object' && fabric && Object.keys(fabric).length) {
        appliedShaders['Ткань'] = fabric['sku'];
    }
    //Опции
    options.forEach(option => {
        if (
            (option['type'] === 'single' || option['type'] === 'required')
            && option['zarbo']
        ) {
            const optionVariation = optionVariations.find(optionVariation => optionVariation['option_id'] === option['id']);
            if (optionVariation) {
                appliedShaders[option['zarbo']] = optionVariation['title'];
            }
        }
    });
    if (!Object.keys(appliedShaders).length) return false;
    //Формируем массивы параметров запроса
    const shaderCodes = [];
    const materialCodes = [];
    for (let shader in appliedShaders) {
        if (shader in allProductShaders) {
            if (allProductShaders[shader].includes(appliedShaders[shader])) {
                shaderCodes.push(shader);
                materialCodes.push(appliedShaders[shader]);
            } else {
                return false;
            }
        }
    }
    if (!shaderCodes.length || !materialCodes.length) return false;

    //Формируем параметры запроса
    const zarboQueryArgs = new URLSearchParams();
    zarboQueryArgs.set('shaderCodes', shaderCodes.join(', '));
    zarboQueryArgs.set('materialCode', materialCodes.join(', '));

    //Формируем ссылку
    const zarboURL = new URL('https://embed.zarbo.tech/'
        + product['zarbo']['product_uuid'] + '/'
        + product['zarbo']['widget_id'] + '/');
    zarboURL.search = zarboQueryArgs;

    return zarboURL.toString();
}

class VariationGallery {
    //Ссылку на 3D-модель галерея спрашивает в момент использования, а не хранит
    constructor(root, getZarboUrl) {
        this.root = root;
        this.getZarboUrl = getZarboUrl;

        jQuery(productForm).on('show_variation', (event, variation) => {
            this.setImages(variation['gallery']);
            this.refreshZarbo();
        });
        jQuery(productForm).on('fabric_changed', (event, fabric) => this.applyZarboFabric(fabric));
        jQuery(productForm).on('options_changed', () => this.refreshZarbo());

        jQuery(document.body).on('click', '.gallery-trigger', () => {
            this.setMode('photo');
        });
        //Свайпер переключается сам (thumbs); showSlide() — если он не засчитал клик (мышь сдвинулась при нажатии)
        jQuery(document.body).on('click', '.variation-gallery__thumbnails-slide', event => {
            if (!this.root.classList.contains('zarbo-active')) return;

            const slide = event.currentTarget;
            this.setMode('photo');
            this.showSlide([...slide.parentNode.children].indexOf(slide));
        });
        jQuery(document.body).on('click', '.variation-gallery__nav', event => {
            const mainSwiper = this.root.querySelector('.main')?.swiper;
            if (!mainSwiper) return;

            event.currentTarget.classList.contains('prev') ? mainSwiper.slidePrev() : mainSwiper.slideNext();
        });
        //На десктопе — zoom на месте, на мобильном и планшете — полноэкранный лайтбокс (slider-gallery.php)
        jQuery(document.body).on('click', '.variation-gallery__main-image', event => {
            if (!isDesktopLayout()) {
                const mainSwiper = this.root.querySelector('.main')?.swiper;
                this.openLightbox(mainSwiper ? mainSwiper.activeIndex : 0);
                return;
            }

            if (!this.canUseZoom()) return;

            const image = event.currentTarget;
            if (image.classList.contains('zoom-in')) {
                image.classList.remove('zoom-in');
                image.style.transformOrigin = 'center center';
                image.style.transform = 'scale(1)';
            } else {
                image.classList.add('zoom-in');
                image.style.transform = 'scale(1.8)';
                this.updateZoomPosition(event);
            }
        });
        jQuery(document.body).on('mousemove', '.variation-gallery__main-image', event => {
            if (this.canUseZoom() && event.currentTarget.classList.contains('zoom-in')) {
                this.updateZoomPosition(event);
            }
        });
        this.root.querySelector('.main')?.swiper?.on('slideChange', swiper => {
            swiper.wrapperEl.querySelectorAll('.variation-gallery__main-image.zoom-in').forEach(image => {
                image.classList.remove('zoom-in');
                image.style.transform = '';
                image.style.transformOrigin = '';
            });
        });
    }

    //Элемент списка — {main, thumbnail}, у каждого {url, srcset, sizes} из get_responsive_image_data()
    setImages(galleryImages) {
        if (!galleryImages || !galleryImages.length) return;

        const thumbnails = this.root.querySelector('.thumbnail');
        if (thumbnails) {
            this.replaceSlides(thumbnails.swiper, galleryImages, 'thumbnail',
                '<div class="variation-gallery__thumbnails-slide slide"><img class="variation-gallery__thumbnails-image"></div>');
        }

        const main = this.root.querySelector('.main');
        if (main) {
            this.replaceSlides(main.swiper, galleryImages, 'main',
                '<div class="variation-gallery__main-slide slide"><img class="variation-gallery__main-image"></div>');
        }

        const lightboxRoot = document.querySelector('[data-gallery-id="variation-gallery"]');
        const lightboxThumbnails = lightboxRoot ? lightboxRoot.querySelector('.gallery-thumbnails') : null;
        if (lightboxThumbnails && lightboxThumbnails.swiper) {
            this.replaceSlides(lightboxThumbnails.swiper, galleryImages, 'thumbnail',
                '<div class="gallery-thumbnails__slide"><img class="gallery-thumbnails__image"></div>');
        }

        const lightboxMain = lightboxRoot ? lightboxRoot.querySelector('.gallery-main') : null;
        if (lightboxMain && lightboxMain.swiper) {
            this.replaceSlides(lightboxMain.swiper, galleryImages, 'main',
                '<div class="gallery-main__slide slide-gallery"><div class="slide-gallery__media"><img class="slide-gallery__image"></div></div>');
        }
    }

    showSlide(index) {
        this.root.querySelector('.main')?.swiper?.slideTo(index, 0);
    }

    //На свёрнутой странице 3D-модель не показываем
    setSideMode(active) {
        this.root.classList.toggle('side-mode', active);
        if (!active && this.root.classList.contains('zarbo-active')) this.setMode('photo');
    }

    //Если 3D-модель для выбора недоступна — возвращаемся к фото
    refreshZarbo() {
        //Кнопок несколько: в миниатюрах на десктопе и сегмент мобильного переключателя
        const triggers = this.root.querySelectorAll('.zarbo-trigger');
        const zarboURL = this.getZarboUrl();

        if (!zarboURL) {
            triggers.forEach(trigger => trigger.classList.add('hidden'));
            if (this.root.classList.contains('zarbo-active')) this.setMode('photo');
            return;
        }

        triggers.forEach(trigger => trigger.classList.remove('hidden'));
        if (this.root.classList.contains('zarbo-active')) this.ensureZarboIframe();
    }

    //Ткань есть в 3D-модели и окно уже создано — меняем ткань командой, без перезагрузки модели
    applyZarboFabric(fabric) {
        const product = current_variation ? current_variation : JSON.parse(productForm.dataset.product);
        const materialCodes = product?.['zarbo']?.['shaders']?.['Ткань'];
        if (materialCodes && materialCodes.some(shader => shader === fabric['sku']) && window.frames.zarbo) {
            this.setZarboMaterial(fabric['sku']);
        } else {
            this.refreshZarbo();
        }
    }

    setZarboMaterial(sku) {
        window.frames.zarbo.postMessage({
            'type': 'change-material',
            'codename': sku
        }, '*');
        //Кнопка могла остаться скрытой с прошлой ткани без 3D
        this.root.querySelectorAll('.zarbo-trigger').forEach(trigger => trigger.classList.remove('hidden'));
    }

    //Фото остаются под панелью 3D-модели со своими размерами — после выхода видно то же фото
    setMode(mode) {
        const active = mode === '3d';
        if (active && !this.getZarboUrl()) {
            this.refreshZarbo();
            return;
        }

        //У десктопной кнопки активный вид — от .zarbo-active на галерее, у кнопок мобильного
        //переключателя — свой класс .active
        this.root.classList.toggle('zarbo-active', active);
        const modeSwitcher = this.root.querySelector('.variation-gallery__mode-switcher');
        modeSwitcher?.querySelector('.zarbo-trigger')?.classList.toggle('active', active);
        modeSwitcher?.querySelector('.gallery-trigger')?.classList.toggle('active', !active);

        //Без анимации: после выхода из 3D нажатое фото видно сразу, а не пролистывание к нему
        const mainSwiper = this.root.querySelector('.main')?.swiper;
        if (mainSwiper) mainSwiper.params.speed = active ? 0 : mainSwiper.originalParams.speed;

        if (active) this.ensureZarboIframe();
    }

    //iframe с той же ссылкой не пересоздаём — повторная загрузка виджета тяжёлая
    ensureZarboIframe() {
        const zarboURL = this.getZarboUrl();
        if (!zarboURL) return;

        const zarboPane = this.root.querySelector('.variation-gallery__zarbo');
        if (zarboPane.querySelector('iframe')?.src === zarboURL) return;

        zarboPane.innerHTML = '';
        zarboPane.appendChild(this.getZarboIframe(zarboURL));
    }

    getZarboIframe(zarboURL) {
        const iframe = document.createElement('iframe');
        iframe.classList.add('variation-gallery__zarbo-iframe');
        iframe.name = 'zarbo';
        iframe.src = zarboURL;
        iframe.loading = 'eager';
        iframe.allow = 'camera; autoplay; xr-spatial-tracking';
        iframe.allowfullscreen = '';
        iframe.frameBorder = 0;
        return iframe;
    }

    //Своя проверка, не canUseGalleryZoom() из dev.js: там граница 1024px, а десктопный вид галереи — от 1240px
    canUseZoom() {
        return isDesktopLayout() && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    updateZoomPosition(event) {
        const rect = event.currentTarget.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        event.currentTarget.style.transformOrigin = (x / rect.width) * 100 + '% ' + (y / rect.height) * 100 + '%';
    }

    //Вместо data-gallery-open: нужный слайд известен только в момент клика
    openLightbox(index) {
        const galleryRoot = document.querySelector('[data-gallery-id="variation-gallery"]');
        if (!galleryRoot) return;

        const mainSwiper = galleryRoot.querySelector('.gallery-main')?.swiper;
        const thumbSwiper = galleryRoot.querySelector('.gallery-thumbnails')?.swiper;
        if (!mainSwiper || !thumbSwiper) return;

        galleryRoot.classList.add('open');
        document.body.classList.add('slider-gallery-open');

        requestAnimationFrame(() => {
            thumbSwiper.update();
            mainSwiper.update();
            if (Number.isInteger(index) && index >= 0 && index < mainSwiper.slides.length) {
                mainSwiper.slideTo(index, 0);
                thumbSwiper.slideTo(index, 0);
            }
        });
    }

    //Через removeAllSlides/appendSlide, а не innerHTML: иначе учёт слайдов Swiper расходится с разметкой
    replaceSlides(swiper, galleryImages, size, slideHtml) {
        const slides = galleryImages.map(galleryImage => {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = slideHtml;
            this.applyResponsiveImage(wrapper.querySelector('img'), galleryImage[size]);
            return wrapper.firstElementChild;
        });
        swiper.removeAllSlides();
        swiper.appendSlide(slides);
        swiper.slideTo(0, 0);
    }

    //Без этого после подстановки фото браузер теряет отзывчивые размеры и грузит самый тяжёлый файл
    applyResponsiveImage(image, data) {
        if (!data) return;
        image.src = data['url'];
        if (data['srcset']) image.srcset = data['srcset'];
        if (data['sizes']) image.sizes = data['sizes'];
    }
}

//Вложен в главный сайдбар; фильтры тканей общие со вкладкой «Ткани», обработчики подключены к главному
class SidebarFabricSelector {
    constructor(root, main, actions) {
        this.root = root;
        this.main = main;
        this.catalog = main.catalog;
        this.actions = actions;
        this.isRendered = false;

        jQuery(productForm).on('show_variation', () => {
            if (!this.isRendered) return;
            const block = this.getFabricPreviousBlock();
            if (block) this.main.fillSelectedFabric(block);
            this.renderFabricFilters();
            this.renderFabrics();
        });
        jQuery(productForm).on('fabric_changed', () => {
            if (!this.isRendered) return;
            this.renderFabricMarks();
            const block = this.getFabricPreviousBlock();
            if (block) {
                this.main.fillSelectedFabric(block);
                this.main.fillFabricsPrevious(block);
            }
        });
        jQuery(this.root).on('click', '.close-trigger', () => this.close());
    }

    open() {
        this.root.classList.add('open');
        if (this.isRendered) return;
        this.isRendered = true;

        if (this.catalog.fabrics.size === 0) {
            this.root.querySelector('.product-constructor-sidebar__main-content')?.remove();
            return;
        }
        this.renderFabricFilters();
        const block = this.getFabricPreviousBlock();
        if (block) {
            this.main.fillSelectedFabric(block);
            this.main.fillFabricsPrevious(block);
        }
        this.renderFabrics();
    }

    close() {
        this.root.classList.remove('open');
    }

    //open — ещё и открыть панель фильтров (после сброса). До первого открытия сайдбара не заполняется
    renderFabricFilters(open = false) {
        const block = this.root.querySelector('.block-fabrics-filters');
        if (!this.isRendered || !block) return;

        renderFabricFiltersBlock(block, this.actions.getFabricFilters(), this.catalog, getBasePrice());
        if (open) openFabricFiltersBlock(block);
    }

    //До первого открытия сайдбара не заполняется
    renderFabrics() {
        const block = this.root.querySelector('.block-fabrics');
        if (!this.isRendered || !block) return;

        renderFabricsBlock(block, 'main', this.actions.getFabricFilters(), this.catalog, getBasePrice());
    }

    renderFabricMarks() {
        this.root.querySelectorAll('.block-fabrics .fabrics').forEach(fabrics => {
            fabrics.querySelector('.item.active')?.classList.remove('active');
            fabrics.querySelector('.item[data-id="' + current_fabric['id'] + '"]')?.classList.add('active');
        });
    }

    getFabricPreviousBlock() {
        return this.root.querySelector('.block-fabric-previous');
    }
}

//Фильтры у образцов свои, не общие с «Смотреть все» и вкладкой «Ткани»
class SidebarFabricSample {
    constructor(root, catalog) {
        this.root = root;
        this.catalog = catalog;
        this.filters = {};
        this.isRendered = false;

        jQuery(productForm).on('show_variation', () => {
            if (!this.isRendered) return;
            this.renderFabrics();
        });
        jQuery(document.body).on('fabrics_samples_changed', () => {
            if (!this.isRendered) return;
            this.renderSamples();
        });
        //dev.js заполняет форму только при изменении образцов — после перезагрузки страницы она оставалась пустой
        jQuery(document).on('pumBeforeOpen', '#pum-65444', () => this.fillOrderForm());
        jQuery(this.root).on('click', '.close-trigger', () => this.close());
        jQuery(this.root).on('click', '.fabrics .item', event => {
            const id = Number(event.currentTarget.dataset.id);
            const fabric = this.catalog.fabrics.get(id);
            if (event.currentTarget.classList.contains('active')) {
                setFabricsSamples(current_fabrics_samples.filter(_fabric => _fabric['id'] !== fabric['id']));
            } else {
                if (current_fabrics_samples.length >= 6 || current_fabrics_samples.some(_fabric => _fabric['id'] === id)) return;
                const fabricsSamples = current_fabrics_samples;
                fabricsSamples.push(fabric);
                setFabricsSamples(fabricsSamples);
            }
        });
        jQuery(this.root).on('click', '.item .sample-remove-trigger', event => {
            const fabric = this.catalog.fabrics.get(Number(event.currentTarget.closest('.item').dataset.id));
            setFabricsSamples(current_fabrics_samples.filter(fabricSample => fabricSample['id'] !== fabric['id']));
        });
        bindFabricFiltersBlocks(this.root, this.catalog, {
            getFilters: () => this.filters,
            getBasePrice: () => getBasePrice(),
            onSearch: () => this.renderFabrics(),
            onChange: () => {
                this.renderFabricFilters();
                this.renderFabrics();
            },
            onReset: () => {
                this.renderFabricFilters(true);
                this.renderFabrics();
            },
        });
    }

    open() {
        this.root.classList.add('open');
        if (this.isRendered) return;
        this.isRendered = true;

        this.renderFabricFilters();
        this.renderFabrics();
        this.renderSamples();
    }

    close() {
        this.root.classList.remove('open');
    }

    //open — ещё и открыть панель фильтров (после сброса)
    renderFabricFilters(open = false) {
        const block = this.root.querySelector('.block-fabrics-filters');
        if (!block) return;

        renderFabricFiltersBlock(block, this.filters, this.catalog, getBasePrice());
        if (open) openFabricFiltersBlock(block);
    }

    renderFabrics() {
        const block = this.root.querySelector('.block-fabrics');
        if (!block) return;

        renderFabricsBlock(block, 'sample', this.filters, this.catalog, getBasePrice());
    }

    renderSamples() {
        this.root.querySelectorAll('.block-fabrics .fabrics .item').forEach(item => {
            item.classList.toggle('active', current_fabrics_samples.some(fabric => fabric['id'] === Number(item.dataset.id)));
        });
        this.root.querySelectorAll('.block-fabric-previews .item').forEach((item, i) => {
            const fabric = current_fabrics_samples[i];
            this.fillSampleItem(item, fabric, fabric?.['preview_url']);
            item.querySelector('.product-constructor-sidebar__fabric-preview-name').innerHTML = fabric ? fabric['title'] : '';
        });
        this.root.querySelectorAll('.block-footer .item').forEach((item, i) => {
            const fabric = current_fabrics_samples[i];
            this.fillSampleItem(item, fabric, fabric ? getFabricPreviewUrl(fabric) : '');
        });
    }

    fillSampleItem(item, fabric, imageUrl) {
        const image = item.querySelector('img');
        if (fabric) {
            item.dataset.id = fabric['id'];
            image.src = imageUrl;
        } else {
            delete item.dataset.id;
            image.removeAttribute('src');
        }
    }

    //Разметка та же, что записывает dev.js при изменении образцов
    fillOrderForm() {
        const list = document.querySelector('.fabrics-samples-modal-list');
        if (!list) return;

        const inputs = document.querySelectorAll('.fabrics-samples-modal .fabric-sample');
        list.innerHTML = '';
        for (let i = 0; i < 6; i++) {
            const fabric = current_fabrics_samples[i];
            if (fabric) {
                const item = document.createElement('div');
                item.classList.add('fabrics-samples-modal__item');
                list.appendChild(item);

                const image = document.createElement('img');
                image.classList.add('fabrics-samples-modal__preview');
                image.src = fabric['preview_url'];
                item.appendChild(image);
            }
            if (inputs[i]) inputs[i].value = fabric ? fabric['title'] : '';
        }
    }
}

//Заполняется только при открытии другой ткани: та же открывается такой, как её оставили
class SidebarFabricDetails {
    constructor(root, catalog, triggerRoots, actions) {
        this.root = root;
        this.catalog = catalog;
        this.actions = actions;
        this.gallery = null;
        this.thumbnails = null;

        jQuery(productForm).on('fabric_changed', () => this.renderButtons());
        jQuery(document.body).on('fabrics_samples_changed', () => this.renderButtons());
        //Клик не выбирает саму ткань под кнопкой
        jQuery(triggerRoots).on('click', '.fabrics .item .fabric-detail-trigger', event => {
            event.stopPropagation();
            const id = Number(event.currentTarget.closest('.fabrics .item').dataset.id);
            if (this.catalog.fabrics.get(id)['type'] !== 'regular') return;

            if (Number(this.root.dataset.id) !== id) this.fill(id);
            jQuery(document.body).trigger('overlay_open');
            this.root.classList.add('open');
        });
        jQuery(document.body).on('overlay_close', () => this.close());
        jQuery(this.root).on('click', '.close-trigger', () => this.close());
        jQuery(this.root).on('click', '.set-fabric-sample-trigger:not(.disabled)', () => {
            const id = Number(this.root.dataset.id);
            if (current_fabrics_samples.length >= 6 || current_fabrics_samples.some(fabric => fabric['id'] === id)) return;

            const fabricsSamples = current_fabrics_samples;
            fabricsSamples.push(this.catalog.fabrics.get(id));
            setFabricsSamples(fabricsSamples);
            this.close();
            this.actions.openSamples();
        });
        jQuery(this.root).on('click', '.set-fabric-trigger', () => {
            const id = Number(this.root.dataset.id);
            if (current_fabric['id'] === id) return;

            this.actions.selectFabric(id);
            this.close();
        });
    }

    close() {
        this.root.classList.remove('open');
    }

    fill(id) {
        const fabric = this.catalog.fabrics.get(id);
        const texture = fabric['texture_id'] ? this.catalog.fabricTextures.get(fabric['texture_id']) : null;
        const category = fabric['category_id'] ? this.catalog.fabricCategories.get(fabric['category_id']) : null;
        this.root.dataset.id = id;

        this.renderGallery([...(fabric['gallery_sample_urls'] || []), ...(fabric['gallery_texture_urls'] || [])]);

        //Название: от 1240 — заголовок «Велюр Leonardo 01», ниже — в шапке после «Ткань»: «Ткань велюр Leonardo 01»
        this.root.querySelector('.product-constructor-sidebar__details-title').innerHTML =
            (texture ? texture['name'] + ' ' : '') + fabric['title'];
        this.root.querySelector('.product-constructor-sidebar__fabric-details-name').innerHTML =
            ' ' + (texture ? texture['name'].toLowerCase() + ' ' : '') + fabric['title'];

        const properties = this.root.querySelector('.product-constructor-sidebar__fabric-details-properties');
        properties.innerHTML = '';
        fabric['property_ids'].forEach(propertyId => {
            const property = this.catalog.fabricProperties.get(propertyId);
            if (!property) return;

            const item = document.createElement('div');
            item.classList.add('product-constructor-sidebar__fabric-details-property');
            item.innerHTML = property['svg'] + property['name'];
            properties.appendChild(item);
        });
        properties.hidden = !properties.children.length;

        //null — строки нет
        const fields = {
            texture: texture ? texture['name'] : null,
            martindale: fabric['martindale'] ? groupFabricDigits(fabric['martindale']) + ' циклов' : null,
            density: fabric['density'] ? groupFabricDigits(fabric['density']) + ' г/м²' : null,
            composition: fabric['composition'] ? fabric['composition'] : null,
            country: fabric['country'] ? fabric['country'] : null,
            ncs: fabric['ncs'] ? withColorScale('NCS', fabric['ncs']) : null,
            ral: fabric['ral'] ? withColorScale('RAL', fabric['ral']) : null,
            category: category ? category['name'] : null,
        };
        this.root.querySelectorAll('.product-constructor-sidebar__fabric-details-list-item').forEach(item => {
            const value = fields[item.dataset.field] ?? null;
            item.hidden = value === null;
            item.querySelector('b').innerHTML = value ?? '';
        });

        //Пустые строки абзацев не дают
        const description = this.root.querySelector('.product-constructor-sidebar__fabric-details-desc');
        const paragraphs = String(fabric['description'] || '').split(/\r\n|\r|\n/).filter(line => line.trim());
        description.innerHTML = paragraphs.map(line => '<p>' + line + '</p>').join('');
        description.hidden = !paragraphs.length;

        this.renderButtons();
        //От 1240 прокручивается колонка с описанием, ниже — вся карточка
        this.root.scrollTop = 0;
        this.root.querySelector('.product-constructor-sidebar__main-content').scrollTop = 0;
    }

    //Сначала фото образцов, потом фактуры
    renderGallery(images) {
        this.gallery?.destroy(true, true);
        this.thumbnails?.destroy(true, true);

        const mainGallery = this.root.querySelector('.product-constructor-sidebar__fabric-details-main-gallery');
        const thumbnailGallery = this.root.querySelector('.product-constructor-sidebar__fabric-details-thumbnail-gallery');
        const mainWrapper = mainGallery.querySelector('.wrapper');
        const thumbnailWrapper = thumbnailGallery.querySelector('.wrapper');
        mainWrapper.innerHTML = '';
        thumbnailWrapper.innerHTML = '';
        images.forEach(imageUrl => {
            mainWrapper.appendChild(this.createSlide('main-gallery', imageUrl));
            thumbnailWrapper.appendChild(this.createSlide('thumbnail-gallery', imageUrl));
        });
        this.root.querySelector('.product-constructor-sidebar__fabric-details-photo').classList.toggle('single', images.length < 2);

        this.thumbnails = new Swiper(thumbnailGallery, {
            'wrapperClass': 'wrapper',
            'slideClass': 'slide',
            'slidesPerView': 'auto',
            'spaceBetween': 12
        });
        this.gallery = new Swiper(mainGallery, {
            'wrapperClass': 'wrapper',
            'slideClass': 'slide',
            'slidesPerView': 1,
            'navigation': {
                'prevEl': mainGallery.querySelector('.prev'),
                'nextEl': mainGallery.querySelector('.next')
            },
            'thumbs': {
                'swiper': this.thumbnails
            }
        });
    }

    createSlide(gallery, imageUrl) {
        const slide = document.createElement('div');
        slide.classList.add('product-constructor-sidebar__fabric-details-' + gallery + '-slide', 'slide');

        const image = document.createElement('img');
        image.classList.add('product-constructor-sidebar__fabric-details-' + gallery + '-image');
        image.src = imageUrl;
        slide.appendChild(image);

        return slide;
    }

    renderButtons() {
        if (!this.root.dataset.id) return;

        const id = Number(this.root.dataset.id);
        this.root.querySelector('.set-fabric-sample-trigger').classList.toggle('disabled',
            current_fabrics_samples.length > 5 || current_fabrics_samples.some(fabric => fabric['id'] === id));
        this.root.querySelector('.set-fabric-trigger').classList.toggle('disabled', current_fabric['id'] === id);
    }
}

//«100000» → «100 000»; делятся только цифры в начале значения («275.4» не меняется)
function groupFabricDigits(value) {
    return String(value).replace(/^\d+/, digits => digits.replace(/\B(?=(\d{3})+$)/g, ' '));
}

//«S 0300-N» → «NCS S 0300-N», «1000» → «RAL 1000»; «RAL 9010» — как есть
function withColorScale(scale, value) {
    return String(value).trim().toUpperCase().startsWith(scale) ? value : scale + ' ' + value;
}

//У вкладки класс .tab-<имя>, у её содержимого — .tab-<имя>-body
const MAIN_SIDEBAR_TABS = ['sizes', 'fabrics', 'options'];

//Всё, что зависит от выбора, заполняется при первом открытии (тогда же грузятся картинки из data-src),
//дальше обновляется точечно по событиям выбора
class SidebarMain {
    constructor(root, catalog, productConstructor, actions) {
        this.root = root;
        this.catalog = catalog;
        this.productConstructor = productConstructor;
        this.actions = actions;
        this.fabricTemplate = document.querySelector('template.product-constructor-fabric-template');
        this.fabricPreviousTemplate = document.querySelector('template.product-constructor-fabric-previous-template');
        this.isRendered = false;

        //До первого открытия сайдбар не заполнен — обновлять нечего
        jQuery(productForm).on('show_variation', () => {
            if (!this.isRendered) return;
            this.renderSizes();
            this.renderOptions();
            this.getFabricPreviousBlocks().forEach(block => this.fillSelectedFabric(block));
            this.renderShortFabricsArMarks();
            this.renderFabrics();
            this.renderTotal();
        });
        jQuery(productForm).on('fabric_changed', () => {
            if (!this.isRendered) return;
            this.renderFabricMarks();
            this.renderTotal();
            this.getFabricPreviousBlocks().forEach(block => {
                this.fillSelectedFabric(block);
                this.fillFabricsPrevious(block);
            });
        });
        jQuery(productForm).on('options_changed', () => {
            if (!this.isRendered) return;
            this.renderOptions();
            this.renderTotal();
        });

        jQuery(this.root).on('click', '.tabs .tab', event => {
            //Ничего не делаем если таб уже выбран
            if (event.currentTarget.classList.contains('active')) return;
            const name = MAIN_SIDEBAR_TABS.find(tab => event.currentTarget.classList.contains('tab-' + tab));
            if (name) this.showTab(name);
        });
        //Выбрать вариацию
        jQuery(this.root).on('click', '.variations .item', event => {
            //Ничего не делаем, если клик по уже выбранному элементу
            if (event.currentTarget.classList.contains('active')) return;
            this.setVariation(Number(event.currentTarget.dataset.id));
            this.scrollToTop();
        });
        jQuery(this.root).on('click', '.options .item:not(.quantity)', event => {
            event.currentTarget.dispatchEvent(new Event('change', {
                bubbles: true,
                cancelable: true
            }));
        });
        //На устройствах без мыши клик открывает описание (с мышью — наведение в стилях)
        jQuery(this.root).on('click', '.product-constructor-sidebar__option-tip', event => {
            event.stopPropagation();
            if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

            const optionDetails = event.currentTarget.parentNode.querySelector('.option-details');
            const shouldOpen = !optionDetails.classList.contains('active');
            this.root.querySelectorAll('.option-details.active')
                .forEach(details => details.classList.remove('active'));
            optionDetails.classList.toggle('active', shouldOpen);
        });
        //От 1240 описание — fixed: иначе его обрезает колонка с overflow: hidden
        jQuery(this.root).on('mouseenter', '.product-constructor-sidebar__option-control-wrapper', event => {
            if (!isDesktopLayout()) return;
            if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
            const details = event.currentTarget.querySelector('.option-details');
            if (details) this.positionOptionDetails(details, event.currentTarget);
        });
        this.root.querySelector('.product-constructor-sidebar__main-content')?.addEventListener('scroll', () => {
            this.repositionHoveredOptionDetails();
        }, { passive: true });
        window.addEventListener('resize', () => this.repositionHoveredOptionDetails());
        jQuery(this.root).on('click', '.option-details', event => event.stopPropagation());
        jQuery(this.root).on('click', '.product-constructor-sidebar__option-details-close, .product-constructor-sidebar__option-details-overlay', event => {
            event.currentTarget.closest('.option-details').classList.remove('active');
        });
        jQuery(this.root).on('change', '.options .item', event => {
            //Получаем id
            const id = Number(event.currentTarget.dataset.id);
            //Получаем опции
            const optionVariation = this.catalog.optionVariations.get(id);
            const option = this.catalog.options.get(optionVariation['option_id']);
            const item = this.root.querySelector('.options .item[data-id="' + id + '"]');
            let optionsVariations = [...current_options_variations];
            if (option['type'] === 'single') {
                if (!item.classList.contains('active')) {
                    optionsVariations = optionsVariations
                        .filter(selectedOptionVariation => selectedOptionVariation['option_id'] !== optionVariation['option_id']);
                    optionsVariations.push(optionVariation);
                } else {
                    //Убираем вариант этой опции
                    optionsVariations = optionsVariations
                        .filter(selectedOptionVariation => selectedOptionVariation['id'] !== optionVariation['id']);
                }
            } else if (option['type'] === 'multiple') {
                if (!item.classList.contains('active')) {
                    optionsVariations.push(optionVariation);
                } else {
                    optionsVariations = optionsVariations
                        .filter(selectedOptionVariation => selectedOptionVariation['id'] !== optionVariation['id']);
                }
            } else if (option['type'] === 'quantity') {
                optionVariation['count'] = Number(item.querySelector('.qty-input').value);
                optionsVariations = optionsVariations
                    .filter(selectedOptionVariation => selectedOptionVariation['id'] !== optionVariation['id']);
                if (optionVariation['count'] > 0) optionsVariations.push(optionVariation);
            } else if (option['type'] === 'required') {
                if (!item.classList.contains('active')) {
                    optionsVariations = optionsVariations
                        .filter(selectedOptionVariation => selectedOptionVariation['option_id'] !== optionVariation['option_id']);
                    optionsVariations.push(optionVariation);
                } else {
                    return;
                }
            }
            this.setOptionsVariations(optionsVariations);
        });
        //Требуется консультация по тканям
        jQuery(this.root).on('click', '.fabric-consultation-trigger', event => {
            const inputManager = document.querySelector('input[name="po[fabric-manager]"]');
            const inputFabric = document.querySelector('input[name="po[fabric]"]');
            const inputFabricCategory = document.querySelector('input[name="po[fabric-category]"]');
            const isChecked = !inputManager.checked;

            //Меняем стиль псевдочекбокса
            const checkboxStylized = event.delegateTarget.querySelector('.fabric-consultation-trigger');
            if (checkboxStylized) {
                isChecked ? checkboxStylized.classList.add('active') : checkboxStylized.classList.remove('active');
            }

            //Устанавливаем значения input'ов
            inputManager.checked = isChecked;
            if (isChecked) {
                inputFabric.disabled = true;
                inputFabricCategory.disabled = true;
            } else {
                if (current_fabric['type'] === 'regular') {
                    inputFabric.disabled = false;
                } else if (current_fabric['type'] === 'catalog') {
                    inputFabricCategory.disabled = false;
                }
            }

            //Во всех блоках, в том числе в сайдбаре выбора ткани
            this.root.querySelectorAll('.block-fabric-previous').forEach(block => this.fillSelectedFabric(block));
            this.root.querySelector('.block-short-fabrics')?.classList.toggle('later', isChecked);
        });
        //Конфигуратор закрываем до отправки: иначе закрытие оверлея мини-корзины закрыло бы и его
        jQuery(this.root).on('click', '.add-to-cart', () => {
            //Закрываем сайдбар
            jQuery(document.body).trigger('overlay_close');
            //Добавляем товар в корзину
            productForm.requestSubmit();
        });
    }

    open() {
        if (this.isRendered) return;
        this.isRendered = true;

        this.root.querySelectorAll('img[data-src]').forEach(image => {
            image.src = image.dataset.src;
            if (image.dataset.srcset !== undefined) image.srcset = image.dataset.srcset;
        });
        if (this.catalog.fabrics.size === 0) {
            this.root.querySelectorAll('.product-constructor-sidebar__basic-fabric-previous, .block-short-fabrics, .tab-fabrics-body')
                .forEach(block => block.remove());
        }
        this.root.querySelectorAll('.variations .item').forEach(item => {
            const variation = this.catalog.variations.get(Number(item.dataset.id));
            item.querySelector('.product-constructor-sidebar__variation-price').innerHTML =
                new Intl.NumberFormat('ru-RU').format(variation['display_price']) + ' ₽';
        });
        this.renderSizes();
        this.renderShortFabrics();
        if (this.root.querySelector('.tab-fabrics-body')) {
            this.renderFabricFilters();
            this.renderFabricList();
        }
        this.renderOptions();
        this.renderWhatsAppLinks();
        this.renderTotal();
        this.getFabricPreviousBlocks().forEach(block => {
            this.fillSelectedFabric(block);
            this.fillFabricsPrevious(block);
        });
    }

    showTab(name) {
        MAIN_SIDEBAR_TABS.forEach(tab => {
            this.root.querySelector('.tabs .tab-' + tab).classList.toggle('active', tab === name);
            this.root.querySelector('.tab-' + tab + '-body').classList.toggle('active', tab === name);
        });
    }

    scrollToTop() {
        if (!isDesktopLayout()) {
            //Прокручивается сам .product-constructor.open вместе с галереей, а не содержимое сайдбара
            this.productConstructor?.scrollTo({ top: 0, behavior: 'smooth' });
            this.actions.getGallery()?.showSlide(0);
            return;
        }

        this.root.querySelector('.product-constructor-sidebar__main-content')?.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    //Правый край описания — у левого края сайдбара, по вертикали — напротив подсказки
    positionOptionDetails(details, anchor) {
        const gap = 40;
        const margin = 20;
        const sidebarLeft = this.root.getBoundingClientRect().left;
        const anchorRect = anchor.getBoundingClientRect();
        const width = details.offsetWidth || 600;
        const height = details.offsetHeight;
        let left = sidebarLeft - gap - width;
        let top = anchorRect.top + anchorRect.height / 2 - height / 2;
        left = Math.max(margin, Math.min(left, window.innerWidth - width - margin));
        top = Math.max(margin, Math.min(top, window.innerHeight - height - margin));
        details.style.left = left + 'px';
        details.style.top = top + 'px';
    }

    repositionHoveredOptionDetails() {
        if (!isDesktopLayout()) return;
        const wrapper = this.root.querySelector('.product-constructor-sidebar__option-control-wrapper:hover');
        const details = wrapper?.querySelector('.option-details');
        if (details) this.positionOptionDetails(details, wrapper);
    }

    renderSizes() {
        const selectedId = getSelectedProduct()['variation_id'];
        this.root.querySelectorAll('.variations .item').forEach(item => {
            item.classList.toggle('active', Number(item.dataset.id) === selectedId);
        });
    }

    renderOptions() {
        this.root.querySelectorAll('.options .item').forEach(item => {
            const id = Number(item.dataset.id);
            const selectedOptionVariation = current_options_variations
                .find(selectedOptionVariation => selectedOptionVariation['id'] === id);
            const price = getOptionVariationPrice(id, this.catalog);

            item.classList.toggle('active', current_options_variations
                .some(selectedOptionVariation => selectedOptionVariation['id'] === id));
            item.querySelector('.product-constructor-sidebar__option-price').innerHTML = price
                ? new Intl.NumberFormat('ru-RU').format(price) + ' ₽' : 'бесплатно';
            const qtyInput = item.querySelector('.qty-input');
            if (qtyInput) qtyInput.value = selectedOptionVariation?.count ?? 0;
        });
    }

    renderShortFabrics() {
        const block = this.root.querySelector('.block-short-fabrics');
        if (!block) return;

        const fabrics = [...this.catalog.fabrics.values()].filter(fabric => fabric['fabric_basic_collection'] === true).slice(0, 9);
        if (fabrics.length === 0) {
            block.remove();
            return;
        }
        const list = block.querySelector('.fabrics');
        fabrics.forEach(fabric => list.appendChild(this.createFabricItem(fabric)));
        block.querySelector('.fabric-select-trigger b').textContent = String(this.catalog.fabrics.size);
    }

    renderShortFabricsArMarks() {
        this.root.querySelectorAll('.block-short-fabrics .fabrics .item').forEach(item => {
            renderFabricArMark(item, this.catalog.fabrics.get(Number(item.dataset.id)));
        });
    }

    createFabricItem(fabric) {
        const item = this.fabricTemplate.content.firstElementChild.cloneNode(true);
        if (fabric['id'] === current_fabric['id']) item.classList.add('active');
        renderFabricArMark(item, fabric);
        item.dataset.id = String(fabric['id']);
        item.querySelector('.product-constructor-sidebar__fabric-image').src = getFabricPreviewUrl(fabric);
        item.querySelector('.product-constructor-sidebar__fabric-title').innerHTML = fabric['title'];
        return item;
    }

    renderFabricMarks() {
        this.root.querySelectorAll('.block-short-fabrics .fabrics, .tab-fabrics-body .block-fabrics .fabrics').forEach(fabrics => {
            fabrics.querySelector('.item.active')?.classList.remove('active');
            fabrics.querySelector('.item[data-id="' + current_fabric['id'] + '"]')?.classList.add('active');
        });
    }

    //Заново: от цены размера зависят наценки категорий и отбор по фильтру цены
    renderFabrics() {
        if (!this.root.querySelector('.tab-fabrics-body')) return;

        this.renderFabricFilters();
        this.renderFabricList();
    }

    //До первого открытия сайдбара не заполняется
    renderFabricList() {
        const block = this.root.querySelector('.tab-fabrics-body .block-fabrics');
        if (!this.isRendered || !block) return;

        renderFabricsBlock(block, 'main', this.actions.getFabricFilters(), this.catalog, getBasePrice());
    }

    //open — ещё и открыть панель фильтров (после сброса)
    renderFabricFilters(open = false) {
        const block = this.root.querySelector('.tab-fabrics-body .block-fabrics-filters');
        if (!block) return;

        renderFabricFiltersBlock(block, this.actions.getFabricFilters(), this.catalog, getBasePrice());
        if (open) openFabricFiltersBlock(block);
    }

    //Без вложенного сайдбара выбора ткани
    getFabricPreviousBlocks() {
        return [...this.root.querySelectorAll('.block-fabric-previous')].filter(block => !block.closest('.fabric-selector'));
    }

    //При консультации по обивке — класс later: вместо ткани «Выберу позже» без наценки
    fillSelectedFabric(block) {
        block.classList.toggle('later', !!document.querySelector('input[name="po[fabric-manager]"]')?.checked);

        const fabric = current_fabric;
        const fabricTexture = this.catalog.fabricTextures.get(fabric['texture_id']);
        let priceText = getFabricCategoryPrice(fabric['category_id'], this.catalog);
        priceText = priceText ? new Intl.NumberFormat("ru-RU").format(priceText) + '₽' : 'Бесплатно';

        block.querySelector('.product-constructor-sidebar__fabric-previous-preview').src = getFabricPreviewUrl(fabric);
        block.querySelector('.product-constructor-sidebar__fabric-previous-name').innerHTML = fabricTexture['name'] + ' ' + fabric['title'];
        block.querySelector('.product-constructor-sidebar__fabric-previous-price').innerHTML = priceText;
    }

    //Ткани, снятой с публикации, здесь нет. Нечего показать — колонка скрыта
    fillFabricsPrevious(block) {
        const column = block.querySelector('.product-constructor-sidebar__fabric-previous-column.fabrics');
        column.querySelectorAll('.item').forEach(item => item.remove());

        JSON.parse(localStorage.getItem('fabrics_previous') || '[]').forEach(fabricId => {
            const fabric = this.catalog.fabrics.get(fabricId);
            if (!fabric) return;

            const item = this.fabricPreviousTemplate.content.firstElementChild.cloneNode(true);
            item.dataset.id = fabric['id'];
            item.title = fabric['title'];
            item.querySelector('.product-constructor-sidebar__fabric-previous-preview').src = getFabricPreviewUrl(fabric);
            column.appendChild(item);
        });
        column.style.display = column.querySelector('.item') ? '' : 'none';
    }

    renderTotal() {
        this.root.querySelector('.sidebar-total-price').innerHTML = '<span>Стоимость конфигурации</span>'
            + new Intl.NumberFormat('ru-RU').format(getTotalPrice(this.catalog)) + ' ₽';
    }

    renderWhatsAppLinks() {
        let ymClientId = document.cookie.match('(?:^|;)\\s*_ym_uid=([^;]*)');
        ymClientId = ymClientId ? decodeURIComponent(ymClientId[1]) : '';
        let ctSessionId = document.cookie.match('(?:^|;)\\s*_ct_session_id=([^;]*)');
        ctSessionId = ctSessionId ? decodeURIComponent(ctSessionId[1]) : '';

        this.root.querySelectorAll('.product-constructor-sidebar__social-link.wa').forEach(link => {
            link.href = 'https://api.whatsapp.com/send/?phone=74957447222&text=Добрый день, у меня вопрос по товару: '
                + getSelectedProduct()['title']
                + '. Просьба, чтобы мы не потеряли ваше обращение, не удаляйте эту строчку:' + ymClientId + ' · '
                + ctSessionId + '&type=phone_number&app_absent=0';
        });
    }

    setVariation(id) {
        //Получаем объект вариации, что хотим применить
        const variation = this.catalog.variations.get(Number(id));

        //Устанавливаем значения атрибутов у селекторов
        Object.keys(variation['attributes']).forEach(attribute => {
            document.querySelector('.variations select.variations-selector[data-attribute_name="' + attribute + '"]')
                .value = variation['attributes'][attribute];
        });

        //Тригерим проверку атрибутов и установку новой вариации
        jQuery(productForm).trigger('woocommerce_variation_select_change');
        jQuery(productForm).trigger('check_variations');
    }

    setOptionsVariations(optionsVariations) {
        optionsVariations = optionsVariations.sort((a, b) => a['id'] - b['id']);

        const optionGroups = [];
        const options = [];
        optionsVariations.forEach(optionVariation => {
            if (!(optionGroups.some(group => group['id'] === optionVariation['group_id']))) {
                optionGroups.push(this.catalog.optionGroups.get(optionVariation['group_id']));
            }
            if (!(options.some(option => option['id'] === optionVariation['option_id']))) {
                options.push(this.catalog.options.get(optionVariation['option_id']));
            }
        });

        jQuery(productForm).trigger('options_changed',
            [structuredClone(optionsVariations), structuredClone(optionGroups), structuredClone(options)]);
    }
}

class ProductConstructor {
    constructor() {
        this.sidebarMain = productForm.querySelector('.product-constructor-sidebar.main');
        this.productConstructor = productForm.closest('.product-constructor');
        this.sidebarFabricSelector = productForm.querySelector('.product-constructor-sidebar.fabric-selector');
        this.sidebarFabricSample = productForm.querySelector('.product-constructor-sidebar.fabric-sample');
        this.sidebarFabricDetails = productForm.querySelector('.product-constructor-sidebar.fabric-details');
        this.catalog = parseProductCatalog(productForm);
        reportOptionsWithoutImage(this.catalog);
        this.fabricSelectorFilters = {};
        //Создаётся до выбора по умолчанию: этот выбор список пропускает, строки при загрузке выводит PHP
        this.summary = new ConstructorSummary(document.querySelector('.product-constructor-list'));
        //Фильтры тканей у вкладки «Ткани» и «Смотреть все» общие
        this.main = new SidebarMain(this.sidebarMain, this.catalog, this.productConstructor, {
            getGallery: () => this.gallery,
            getFabricFilters: () => this.fabricSelectorFilters,
        });
        this.fabricSelector = new SidebarFabricSelector(this.sidebarFabricSelector, this.main, {
            getFabricFilters: () => this.fabricSelectorFilters,
        });
        this.fabricSample = new SidebarFabricSample(this.sidebarFabricSample, this.catalog);
        this.fabricDetails = new SidebarFabricDetails(this.sidebarFabricDetails, this.catalog, [this.sidebarMain, this.sidebarFabricSample], {
            selectFabric: id => this.selectFabric(id),
            openSamples: () => {
                jQuery(document.body).trigger('overlay_open');
                this.fabricSample.open();
            },
        });
        //Сайдбар выбора ткани вложен в главный — обработчики на главном ловят и его события
        bindFabricFiltersBlocks(this.sidebarMain, this.catalog, {
            getFilters: () => this.fabricSelectorFilters,
            getBasePrice: () => getBasePrice(),
            onSearch: () => {
                this.main.renderFabricList();
                this.fabricSelector.renderFabrics();
            },
            onChange: () => {
                this.main.renderFabricFilters();
                this.main.renderFabricList();
                this.fabricSelector.renderFabricFilters();
                this.fabricSelector.renderFabrics();
            },
            onReset: () => {
                this.main.renderFabricFilters(true);
                this.main.renderFabricList();
                this.fabricSelector.renderFabricFilters(true);
                this.fabricSelector.renderFabrics();
            },
        });

        //Действия
        //Установить текущую ткань
        if (this.catalog.fabrics.size > 0) this.setFabric(Number(productForm.querySelector('input[name="po[fabric]"]').value));
        //Установить активные вариации опций
        const optionsVariations = [];
        this.catalog.options.forEach(option => {
            if (option['type'] === 'required') {
                const optionVariation = [...this.catalog.optionVariations.values()]
                    .find(optionVariation => optionVariation['option_id'] === option['id']);
                if (optionVariation) optionsVariations.push(optionVariation);
            }
        });
        this.main.setOptionsVariations(optionsVariations);
        const galleryRoot = document.querySelector('.variation-gallery');
        this.gallery = galleryRoot ? new VariationGallery(galleryRoot, () => this.getZarboURL()) : null;
        this.gallery?.refreshZarbo();


        //События
        //Открыть сайдбар товара
        jQuery(document).on('click', 'body.single-product form.cart .product-constructor-sidebar-trigger, .product-scroll-line .product-constructor-sidebar-trigger', (evt) => {
            this.openConfigurator();
            this.gallery?.setMode('3d');

            //Открываем сайдбар товара по кнопкам выбора ткани и размера
            if (evt.currentTarget.classList.contains('product-constructor__item-wrapper')) {
                if (evt.currentTarget.parentNode.classList.contains('size')) {
                    if (isDesktopLayout()) {
                        //Не scrollIntoView(): сайдбар ещё выезжает, и прокрутилась бы колонка — сайдбар остался бы
                        //сдвинутым за её край
                        const mainContent = this.sidebarMain.querySelector('.product-constructor-sidebar__main-content');
                        const sizesBody = this.sidebarMain.querySelector('.tab-sizes-body');
                        if (mainContent) {
                            mainContent.scrollTop += sizesBody.getBoundingClientRect().top - mainContent.getBoundingClientRect().top;
                        }
                    } else {
                        this.main.showTab('sizes');
                    }
                }
                if (evt.currentTarget.parentNode.classList.contains('fabric')) {
                    if (isDesktopLayout()) {
                        //Открываем оверлей
                        jQuery(document.body).trigger('overlay_open');
                        //Открываем сайдбар тканей
                        this.fabricSelector.open();
                    } else {
                        this.main.showTab('fabrics');
                    }
                }
                if (evt.currentTarget.parentNode.classList.contains('option')) {
                    if (isDesktopLayout()) {
                        const mainContent = this.sidebarMain.querySelector('.product-constructor-sidebar__main-content');
                        const blockOptions = this.sidebarMain.querySelector('.block-options');
                        if (mainContent) {
                            mainContent.scrollTop += blockOptions.getBoundingClientRect().top - mainContent.getBoundingClientRect().top;
                        }
                    } else {
                        this.main.showTab('options');
                    }
                }
            }
        });
        //Закрыть сайдбар товара
        jQuery(document.body).on('overlay_close', () => {
            jQuery('html').css('overflow', '');
            //Закрываем сайдбар товара
            this.closeMainSidebar();
        });
        //Слушаем на погружении, раньше лайтбоксов dev.js: открытый поверх лайтбокс Esc закрывает сам.
        //Окна Popup Maker тоже закрываются сами, конфигуратор остаётся. Окно фильтров закрывается без применения
        document.addEventListener('keydown', event => {
            if (event.key !== 'Escape' || document.querySelector('[data-gallery-id].open')) return;

            const popup = document.querySelector('.pum.pum-active');
            if (popup && this.productConstructor?.classList.contains('open')) {
                popup.querySelector('.pum-close')?.click();
                return;
            }

            const filterWindow = document.querySelector('.product-constructor-sidebar .fabric-filter-body.window-open');
            if (filterWindow) {
                filterWindow.querySelector('.fabric-filter-close-trigger')?.click();
                return;
            }

            const nestedSidebar = [this.sidebarFabricDetails, this.sidebarFabricSample, this.sidebarFabricSelector]
                .find(sidebar => sidebar?.classList.contains('open'));
            if (nestedSidebar) {
                nestedSidebar.querySelector('.close-trigger')?.click();
            } else if (this.productConstructor?.classList.contains('open')) {
                this.sidebarMain.querySelector('.close-overlay-trigger')?.click();
            }
        }, true);
        //Конфигуратор ещё не открыт — сначала открываем его, как кнопка «Открыть конфигуратор»
        jQuery(document.body).on('click', '.zarbo-trigger', () => {
            if (!this.productConstructor?.classList.contains('open')) this.openConfigurator();
            this.gallery?.setMode('3d');
        });
        //Только на главном сайдбаре: события вложенного выбора ткани он ловит сам, иначе обработка была бы двойной
        jQuery(this.sidebarMain).on('click', '.fabrics .item', event => {
            //Ничего не делаем, если клик по уже выбранному элементу
            if (event.currentTarget.classList.contains('active')) return;
            //При консультации по обивке ткани «Последнего выбора» не выбираются
            if (event.currentTarget.closest('.block-fabric-previous.later')) return;
            this.selectFabric(Number(event.currentTarget.dataset.id));
            if (!isDesktopLayout()) {
                this.productConstructor?.scrollTo({ top: 0, behavior: 'smooth' });
            }
        });
        //Открыть сайдбар тканей
        jQuery(this.sidebarMain).on('click', '.fabric-select-trigger', () => {
            //Открываем оверлей
            jQuery(document.body).trigger('overlay_open');
            //Открываем сайдбар тканей
            this.fabricSelector.open();
        });
        jQuery(document.body).on('overlay_close', () => this.fabricSelector.close());
        //Открыть сайдбар образцов тканей
        jQuery(this.sidebarMain).on('click', '.fabric-sample-trigger', () => {
            //Открываем оверлей
            jQuery(document.body).trigger('overlay_open');
            //Открываем сайдбар образцов тканей
            this.fabricSample.open();
        });
        //Главный сайдбар под образцами остаётся как был — с той же вкладкой и прокруткой
        jQuery(document.body).on('overlay_close', () => this.fabricSample.close());

        jQuery(document).on('click', '.product-variations-cards__card', event => {
            if (event.button !== 0 || event.ctrlKey || event.shiftKey || event.metaKey || event.altKey) return;

            const variation = this.findVariationByUrl(event.currentTarget.href);
            if (!variation) return;

            event.preventDefault();
            if (Number(variation['variation_id']) !== Number(current_variation['variation_id'])) {
                this.main.setVariation(variation['variation_id']);
            }
            this.scrollPageToConstructor();
        });
    }

    scrollPageToConstructor() {
        if (!this.productConstructor) return;
        const scrollLine = document.querySelector('.product-scroll-line:not(.product-scroll-line--bottom)');
        const top = this.productConstructor.getBoundingClientRect().top + window.scrollY - (scrollLine?.offsetHeight || 0);
        window.scrollTo({ top, behavior: 'smooth' });
    }

    findVariationByUrl(href) {
        const searchParams = new URL(href).searchParams;
        return [...this.catalog.variations.values()].find(variation => {
            const attributes = Object.entries(variation['attributes']);
            return attributes.length > 0
                && attributes.every(([attribute, value]) => searchParams.get(attribute) === value);
        });
    }

    //Ткань есть в 3D-модели, а галерея показывает фото — переключаемся в 3D. Если 3D уже открыта, ткань в ней
    //сменила команда окну по fabric_changed — повторное включение перезагрузило бы модель
    selectFabric(id) {
        const fabric = this.catalog.fabrics.get(id);
        const fabricsPrevious = JSON.parse(localStorage.getItem('fabrics_previous') || '[]')
            .filter(fabricId => fabricId !== fabric['id'] && fabricId !== current_fabric['id']);
        if (current_fabric['id'] !== fabric['id']) fabricsPrevious.unshift(current_fabric['id']);
        fabricsPrevious.unshift(fabric['id']);
        localStorage.setItem('fabrics_previous', JSON.stringify(fabricsPrevious.slice(0, 6)));
        this.setFabric(id);
        if (
            this.gallery
            && this.productConstructor?.classList.contains('open')
            && !this.gallery.root.classList.contains('zarbo-active')
            && isFabricInZarbo(fabric)
        ) {
            this.gallery.setMode('3d');
        }
    }

    openConfigurator() {
        jQuery(document.body).trigger('overlay_open');
        jQuery('html').css('overflow', 'hidden');
        this.openMainSidebar();
    }

    openMainSidebar() {
        this.productConstructor?.classList.add('open');
        this.gallery?.setSideMode(true);
        this.main.open();
    }

    closeMainSidebar() {
        this.productConstructor?.classList.remove('open');
        this.gallery?.setSideMode(false);
    }

    //false — 3D-модель для текущего выбора недоступна
    getZarboURL() {
        //Объект товара/вариации
        let product = {};
        const selectedProduct = getSelectedProduct();
        if (
            typeof selectedProduct === 'object'
            && Object.keys(selectedProduct).length
        ) {
            product = selectedProduct;
        } else if (productForm && productForm.dataset.product) {
            product = JSON.parse(productForm.dataset.product);
        }

        return buildZarboUrl(product, current_fabric, current_options_variations || [], this.catalog.options);
    }

    setFabric(id) {
        //Получить объект ткани, что хотим применить
        const fabric = this.catalog.fabrics.get(Number(id));
        const color = this.catalog.fabricColors.get(fabric['color_id']) ? this.catalog.fabricColors.get(fabric['color_id']) : null;
        const category = this.catalog.fabricCategories.get(fabric['category_id']) ? this.catalog.fabricCategories.get(fabric['category_id']) : null;
        const texture = this.catalog.fabricTextures.get(fabric['texture_id']) ? this.catalog.fabricTextures.get(fabric['texture_id']) : null;
        let properties = [];
        fabric['property_ids'].forEach(propertyId => {
            if (this.catalog.fabricProperties.get(fabric[propertyId])) properties.push(this.catalog.fabricProperties.get(fabric[propertyId]));
        });

        //Устанавливаем ткань
        jQuery(productForm).trigger('fabric_changed', [fabric, color, category, texture, properties]);
    }

}

document.querySelectorAll('form.cart').forEach(function(productForm) {
    if (productForm.classList.contains('simple_form')) {
        new ProductConstructor(productForm);
    } else if (productForm.classList.contains('variations_form')) {
        jQuery(productForm).one('show_variation', () => {
            new ProductConstructor(productForm);
        });
    }
});
